import { Skeleton } from "antd";
import { MenuItem } from "api/config/model/AppConfigResponseModel";
import Main from "components/layout/MainAppLayout";
import MainPage from "features/Dashboard/view/Dashboard";
import DetailPage from "features/Detail/view/DetailPage";
import DKTTBDetail from "features/Order/view/dkttb/DKTTBDetail";
import DKTTBInfo from "features/Order/view/dkttb/DKTTBInfo";
import PickSimPage from "features/Order/view/pickSim/PickSimPage";
import ShoppingCartPage from "features/Order/view/shoppingCart/ShoppingCartPage";
import UnknownPage from "features/Unknown/UnknownPage";
import { useAuth } from "global/context/AuthenticationContext";
import { HOST_MENUS } from "navigation/AppMenu";
import AppPages from "navigation/AppPages";
import React, { Suspense, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import "reflect-metadata";
import "./App.css";
import MaintenanceGuard from "components/layout/MaintenanceGuard";
import AppApi from "api/App/AppApi";

function App() {
  const { isAuthenticated, config } = useAuth();
  const [maintenanceOrder, setMaintenanceOrder] = useState([]);

  const fetchStatusMaintenanceOrder = async () => {
    
    try {
      const response = await AppApi.getMaintenanceFeatures({limit: 100, telco: "1",});
      setMaintenanceOrder(response?.data?.items ?? []);
    } catch (err) {
      console.log("Không lấy được trạng thái bảo trì");
    }
  };

  useEffect(() => {
    console.log("🔥 useEffect RUN");
    fetchStatusMaintenanceOrder();

    const interval = setInterval(fetchStatusMaintenanceOrder, 30000);

    if (process.env.NODE_ENV == "development") {
      return () => clearInterval(interval);
    }
    const handleContextmenu = (e: any) => {
      e.preventDefault();
    };
    document.addEventListener("contextmenu", handleContextmenu);
    return function cleanup() {
      clearInterval(interval);
      document.removeEventListener("contextmenu", handleContextmenu);
    };
  }, []);

  const wrap = (C: React.ComponentType<any>) => (
    <Suspense fallback={<Skeleton active />}>
      <C />
    </Suspense>
  );

  const renderHostRoutes = () => {
    return (
      <Routes>
        {HOST_MENUS.map((menu) => {
          const C = AppPages.getPage(menu.componentName);

          return <Route key={menu.path} path={menu.path} element={wrap(C)} />;
        })}
      </Routes>
    );
  };

  const renderAuthenticatedRoutes = () => {
    return (
      <Routes>
        <Route path="/*"
          element={
            <MaintenanceGuard maintenanceOrder={maintenanceOrder}>
              <Main />
            </MaintenanceGuard>
          }
        // element={<Main />}
        >
          <Route index element={wrap(MainPage)} />
          {config.menu.map((menu: MenuItem) => {
            const rel = menu.path.replace(/^\//, "");
            const C = AppPages.getPage(menu.componentName);
            return <Route key={menu.path} path={rel} element={wrap(C)} />;
          })}
          {config.menu.flatMap((menu) =>
            (menu.subMenu || []).map((sub) => {
              const rel = sub.path.replace(/^\//, "");
              const C = AppPages.getPage(sub.componentName);
              return <Route key={sub.path} path={rel} element={wrap(C)} />;
            }),
          )}
          <Route path="detail" element={wrap(DetailPage)} />
          <Route path="order/dkttb/:id" element={wrap(DKTTBInfo)} />
          <Route path="order/dkttb-detail/:id" element={wrap(DKTTBDetail)} />
          <Route path="pick-sim/:id" element={wrap(PickSimPage)} />
          <Route path="shopping-cart/*" element={wrap(ShoppingCartPage)} />
          <Route path="*" element={wrap(UnknownPage)} />
        </Route>
      </Routes>
    );
  };

  const renderContent = () => {
    if (!isAuthenticated) {
      return renderHostRoutes();
    }

    if (!config?.menu) {
      return <Skeleton active />;
    }

    if (config.menu.length === 0) {
      return renderHostRoutes();
    }

    return renderAuthenticatedRoutes();
  };

  return <div className="App">{renderContent()}</div>;
}

export default App;
